@if (busy) {
  <div class="loading-image-container">
    <div class="loading-image small"></div>
    <div class="loading-text">{{ busyMessage }}</div>
  </div>
}
<div class="tile-wrapper">
  <mat-card>
    <mat-card-title
      >New {{ viewModel?.Title || "" }} Import</mat-card-title
      >
    </mat-card>
    @if (provisioningJob) {
      <mat-card>
        <mat-card>
          <mat-card-title>Processing Import</mat-card-title>
          <mat-card-subtitle
            >You can close this window and the processing will continue in the
            background.</mat-card-subtitle
            >
          </mat-card>
          <mat-card>
            <mat-card-title>Progress</mat-card-title>
            <mat-card-content>
              @if (provisioningJob) {
                <job-liveview
                  [jobId]="provisioningJob"
                  (finished)="jobComplete($event)"
                ></job-liveview>
              }
            </mat-card-content>
          </mat-card>
        </mat-card>
      }
      @if (viewModel && !importResult && !provisioningJob) {
        <div>
          @if (isModuleInputRequired) {
            <div>
              <mat-card>
                <mat-card-subtitle
                  >Choose the module to import against</mat-card-subtitle
                  >
                  <mat-card-content>
                    <br />
                    <mat-select
                      matInput
                      id="importForModule"
                      placeholder="Module"
                      [(ngModel)]="selectedModuleId"
                      [required]="isModuleInputRequired"
                      (selectionChange)="setModule($event)"
                      >
                      @for (mi of viewModel.Modules; track mi) {
                        <mat-option [value]="mi.Key">{{
                          mi.Value
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-card-content>
                </mat-card>
              </div>
            }
            @if (showFileFormatCard()) {
              <mat-card>
                <mat-card-title>File Format</mat-card-title>
                <mat-card-subtitle
                  >Choose the file format of the import file.</mat-card-subtitle
                  >
                  <mat-card-content>
                    <br />
                    <mat-select
                      matInput
                      id="fileType"
                      placeholder="File Format"
                      [(ngModel)]="selectedFormat"
                      style="width: 400px"
                      >
                      @for (ft of viewModel.Formats; track ft) {
                        <mat-option [value]="ft">{{
                          ft.Name
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-card-content>
                </mat-card>
              }
              @if (selectedFormat) {
                <mat-card>
                  <mat-card-title>Upload File</mat-card-title>
                  <mat-card-content>
                    <label for="fileInput"></label>
                    <div>
                      <h4>{{ filename }}</h4>
                    </div>
                    <mat-card-subtitle
                      >Your file name must start with {{ tenantName }}_ and be encoded in
                      UTF-8.</mat-card-subtitle
                      >
                      <button
                        mat-raised-button
                        class="mat-accent tableBtn"
                        (click)="fileInput.click()"
                        >
                        <mat-icon>file_upload</mat-icon> Browse File&nbsp;&nbsp;&nbsp;
                      </button>
                      @if (isValidateButtonDisplayed) {
                        <button
                          mat-raised-button
                          class="mat-accent tableBtn"
                          (click)="validate()"
                          [disabled]="isValidateButtonDisabled"
                          >
                          <mat-icon>playlist_add_check</mat-icon> Validate
                          File&nbsp;&nbsp;&nbsp;
                        </button>
                      }
                      <input
                        hidden
                        type="file"
                        id="fileInput"
                        #fileInput
                        (change)="previewFile($event)"
                        [accept]="selectedFormat.Extensions"
                        />
                      @if (viewModel.FormatError) {
                        <div style="padding-top: 1em">
                          <span class="error is-flex is-aligned-centre">
                            <mat-icon>highlight_off</mat-icon> {{ viewModel.FormatError }}
                          </span>
                        </div>
                      }
                    </mat-card-content>
                  </mat-card>
                }
                @if (viewModel?.Top5Rows?.length > 0) {
                  <mat-card>
                    <mat-card-title>Preview</mat-card-title>
                    <mat-card-content>
                      <div class="preview">
                        <table>
                          <tbody>
                            @for (r of viewModel.Top5Rows; track r) {
                              <tr>
                                @for (c of r; track c) {
                                  <td>
                                    {{ c }}
                                  </td>
                                }
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (viewModel.ValidationComplete) {
                  <mat-card>
                    <mat-card-title>Validation Results</mat-card-title>
                    <mat-card-content>
                      <form #doImportForm="ngForm" (ngSubmit)="import()">
                        <div>
                          @for (setting of viewModel.AdditionalSettings; track setting) {
                            <div>
                              <br />
                              <app-list-items-import
                                [setting]="setting"
                                [additionalValues]="additionalValues"
                              ></app-list-items-import>
                              <hr />
                            </div>
                          }
                        </div>
                        @if (isImportButtonDisplayed) {
                          <button
                            mat-raised-button
                            class="mat-accent tableBtn"
                            [disabled]="isImportButtonDisabled"
                            >
                            <mat-icon>play_circle_outline</mat-icon> Import Data
                            @if (hasErrors()) {
                              <span
                                ><em>(Rows and nodes with errors will be excluded)</em></span
                                >
                                }&nbsp;&nbsp;&nbsp;
                              </button>
                            }
                            @if (!viewModel.Failed) {
                              <div>
                                <h3>Validated Nodes Summary</h3>
                                @for (l of viewModel.LevelCounts; track l) {
                                  <p>
                                    <strong>{{ l.Key }}</strong
                                      >: {{ l.Value }}
                                    </p>
                                  }
                                  <p>
                                    <span class="error">
                                      @if (viewModel?.LevelCounts?.length === 0) {
                                        <strong
                                          >No Valid Nodes were found</strong
                                          >
                                        }
                                      </span>
                                    </p>
                                  </div>
                                }
                                @if (viewModel?.ErrorRows?.length > 0) {
                                  <div
                                    style="overflow: scroll"
                                    >
                                    <hr />
                                    <h3>Row Errors</h3>
                                    <table>
                                      <tbody>
                                        @for (r of viewModel.ErrorRows; track r) {
                                          <tr>
                                            @for (f of r.Fields; track f; let i = $index) {
                                              <td
                                                [class]="getFieldClass(r, i)"
                                                >
                                                {{ f }}
                                              </td>
                                            }
                                          </tr>
                                          <tr>
                                            <td [attr.colspan]="r.Fields.length">
                                              <p>
                                                Row Number: <strong>{{ r.RowNumber }}</strong>
                                              </p>
                                              @for (e of r.Errors; track e) {
                                                <p>
                                                  <span class="error">
                                                    <mat-icon>highlight_off</mat-icon> {{ e.Message }}
                                                  </span>
                                                </p>
                                              }
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                }
                                @if (viewModel?.WarningRows?.length > 0) {
                                  <div
                                    style="overflow: scroll; margin-top: 1ex"
                                    >
                                    <hr />
                                    <h3>Row Warnings</h3>
                                    <table>
                                      <tbody>
                                        @for (r of viewModel.WarningRows; track r) {
                                          <tr>
                                            @for (f of r.Fields; track f; let i = $index) {
                                              <td>{{ f }}</td>
                                            }
                                          </tr>
                                          <tr>
                                            <td [attr.colspan]="r.Fields.length">
                                              <p>
                                                Row Number: <strong>{{ r.RowNumber }}</strong>
                                              </p>
                                              @for (e of r.Warnings; track e) {
                                                <p>
                                                  <span class="warning">
                                                    <mat-icon>info</mat-icon> {{ e.Message }}
                                                  </span>
                                                </p>
                                              }
                                            </td>
                                          </tr>
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                }
                                @if (viewModel?.NodeErrors?.length > 0) {
                                  <div>
                                    <hr />
                                    <h3>Node Errors</h3>
                                    @for (n of viewModel.NodeErrors; track n) {
                                      <div class="node-error">
                                        <p>
                                          Description: <strong>{{ n.NodeDescription }}</strong>
                                        </p>
                                        <p>
                                          <span class="error"
                                            ><mat-icon>highlight_off</mat-icon> {{ n.Error }}</span
                                            >
                                          </p>
                                        </div>
                                      }
                                    </div>
                                  }
                                  @if (viewModel.ValidationError) {
                                    <div>
                                      <div class="node-error">
                                        <p>
                                          <strong>{{ viewModel.ValidationError }}</strong>
                                        </p>
                                        <p>
                                          <span class="error"
                                            ><mat-icon>highlight_off</mat-icon>
                                            {{ viewModel.ValidationErrorDetail }}</span
                                            >
                                          </p>
                                        </div>
                                      </div>
                                    }
                                    @if (!hasErrors()) {
                                      <div class="all-good">
                                        <mat-icon>check_circle</mat-icon> No Errors Found
                                      </div>
                                    }
                                  </form>
                                </mat-card-content>
                              </mat-card>
                            }
                          </div>
                        }
                        @if (importResult && false) {
                          <div>
                            <mat-card>
                              <mat-card-title>Import Results</mat-card-title>
                              <mat-card-content>
                                @if (importResult.Success) {
                                  <div class="all-good">
                                    <mat-icon>check_circle</mat-icon> No Errors Found, Import Successful
                                  </div>
                                }
                                @if (!importResult.Success) {
                                  <div>
                                    @for (e of importResult.Errors; track e) {
                                      <p>
                                        <span class="error"
                                          ><mat-icon>highlight_off</mat-icon> {{ e }}</span
                                          >
                                        </p>
                                      }
                                    </div>
                                  }
                                </mat-card-content>
                              </mat-card>
                            </div>
                          }
                        </div>
